import { type IMapTabRow } from "commonComponents/entity/map/MapTab/MapTab.api.types";
import { GridEntity } from "commonComponents/utilities/Grid/GridContainer.types";

export type JobListFormActions = "newJob" | undefined;

export enum JobListTabs {
    List = 0,
    Map = 1,
}

export interface IGeoLocation {
    latitude?: number;
    longitude?: number;
}

export enum JobListGridColumns {
    ProjectedCosts = 85,
    ProjectedProfit = 86,
}

export class JobGridEntity extends GridEntity<{}, IMapTabRow> {
    constructor(data: any) {
        super(data);
        // TODO: handle permission logic here
        this.createdJobCountForBuilder = data.createdJobCountForBuilder;
        this.accountingImportIntegrationName = data.accountingImportIntegrationName;
        if (data.data) {
            this.data = this.data.map((x: any) => {
                const { ...otherRows } = x;

                return Object.assign({
                    address: x.jobAddress,
                    nameLink: x.jobNameLink,
                    displayName: x.ownerDisplayName,
                    ...otherRows,
                });
            });
        }
    }

    createdJobCountForBuilder?: number;
    accountingImportIntegrationName: string;
}
